import React from 'react';

const HtmlContent = ({ htmlString }) => {
    return (
        <div className="htmlContentChatBot"
            dangerouslySetInnerHTML={{ __html: htmlString }}
        />
    );
};

const ChatBotMarkDownContent = ({ htmlContent }) => {

    return (
        <div>
            <style>
                {`
                    .htmlContentChatBot {
                        display: flex;
                        flex-direction: column;
                        padding: 0px 10px 10px 10px !important;
                        border: none !important;
                    }
                    .htmlContentChatBot table {
                        width: 100% !important;
                         height: auto !important;
                        text-align: center !important;
                        border-collapse: collapse !important;
                        display: block !important; 
                        overflow-x: auto !important; 
                    }
                    .htmlContentChatBot table th {
                        white-space: nowrap !important;
                        color: #000 !important;
                        background-color: #F4F4F4 !important;
                    }
                    .htmlContentChatBot table td {
                        background-color: #F4F4F4 !important;
                    }
                   .htmlContentChatBot ol, .htmlContentChatBot ul {
                        list-style: revert !important;
                        list-style-type: revert !important;
                        margin: revert;
                        padding: revert;
                    }
                    .htmlContentChatBot table th, .htmlContentChatBot table td {
                        padding: 10px !important;
                        border: 1px solid #ddd !important;
                    }
                    .htmlContentChatBot h1 {
                        font-size: 28px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContentChatBot h2 {
                        font-size: 24px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContentChatBot h3 {
                        font-size: 20px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContentChatBot h4 {
                        font-size: 16px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContentChatBot h5 {
                        font-size: 12px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContentChatBot h6 {
                        font-size: 8px !important;
                        font-weight:bold !important;
                        margin: revert;
                    }
                    .htmlContentChatBot p {
                        margin: revert;
                    }
                    textarea {
                        width: 100% !important;
                    }
                `}
            </style>
            <HtmlContent htmlString={htmlContent} />
        </div>
    )
}
export default ChatBotMarkDownContent;